import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Caught:', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#0f1117', color: '#e8e9ed', fontFamily: "'DM Sans',sans-serif", gap: 16, padding: 24, textAlign: 'center' }}>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#c8372d' }}>Something went wrong</div>
          <div style={{ fontSize: 14, color: '#8b8f9e', maxWidth: 400 }}>
            {this.state.error?.message || 'An unexpected error occurred.'}
          </div>
          <button
            onClick={() => { this.setState({ hasError: false, error: null }); }}
            style={{ marginTop: 12, border: 'none', borderRadius: 8, padding: '10px 24px', fontSize: 13, fontWeight: 600, cursor: 'pointer', background: '#3b82f6', color: '#fff', fontFamily: "'DM Sans',sans-serif" }}
          >
            Try Again
          </button>
          <button
            onClick={() => window.location.reload()}
            style={{ border: 'none', borderRadius: 8, padding: '8px 20px', fontSize: 12, cursor: 'pointer', background: 'transparent', color: '#8b8f9e', fontFamily: "'DM Sans',sans-serif" }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
